'use client';

import { PropsWithChildren } from 'react';
import { cn } from '../_lib/utils';
import { ButtonLink, ComponentButtonProps } from '../Inputs/Button';
import { AlgoliaSearchBox } from '../AlgoliaSearchBox';
import { GlobalNavSearch } from '../Inputs/GlobalNavSearch';

export type FilterBarProps = PropsWithChildren<{
	className?: string;
	button?: ComponentButtonProps;
	withSearch?: boolean;
	globalSearch?: boolean;
	showFilters?: boolean;
	filters?: string[];
	removeCannotRefine?: boolean;
	locale?: string;
}>;

export function FilterBar(props: FilterBarProps) {
	return (
		<div
			className={cn(
				'flex flex-col items-center gap-responsive-md pb-spacing-md border-b border-border-primary lg:flex-row',
				props.className,
			)}
			data-component='FilterBar'
		>
			{props.children}

			<div className='w-full flex flex-col items-center gap-responsive-md [&>div]:w-full sm:flex-row sm:ml-auto'>
				{props.withSearch && <GlobalNavSearch />}

				{/* {props.button && (
						<ButtonLink parent='CardSectionHeader' href={props.button.link.href} {...props.button.buttonProps} styleSize='large'>
							{props.button.link.label}
						</ButtonLink>
					)} */}
			</div>
		</div>
	);
}
